<!-- components/StatusTag.vue -->
<template>
  <el-tag :type="tagType" :size="size" effect="plain">
    {{ statusText }}
  </el-tag>
</template>

<script>
export default {
  name: 'StatusTag',
  props: {
    status: {
      type: String,
      required: true,
      validator: val => ['ENABLE', 'DISABLE', 'DELETE', 'ACTIVE', 'INACTIVE'].includes(val)
    },
    size: {
      type: String,
      default: 'small',
      validator: val => ['small', 'medium', 'default'].includes(val)
    }
  },
  computed: {
    tagType() {
      const map = {
        ENABLE: 'success',
        ACTIVE: 'success',
        DISABLE: 'danger',
        INACTIVE: 'info',
        DELETE: 'info'
      }
      return map[this.status] || 'info'
    },
    statusText() {
      const map = {
        ENABLE: '启用',
        ACTIVE: '启用',
        DISABLE: '暂停',
        INACTIVE: '停用',
        DELETE: '已删除'
      }
      return map[this.status] || this.status
    }
  }
}
</script>